import React from "react";
import { Link } from "react-router-dom";
import './PageNotFound.css';

function PageNotFound() {
  return (
    <div class="page-not-found">
      <h1>Page Not Found </h1>
      <p>The following page has been moved or is no longer available.</p>
      <h3>
        Return to the application home: <Link to="/"> Home Page</Link>
      </h3>
    </div>
  );
}

export default PageNotFound;
